module.exports = __webpack_public_path__ + "img/accompagner_aidant.2cc4ecee.png";